<div class="login-progress">
  <div class="progress-box">Your are being logged out...</div>
</div>
